'use client';

import { useState } from 'react';
import { Button } from '../Button/Button';

const integrations = [
  {
    name: 'Neural Amp Modeler Plugin (Official)',
    type: 'Plugin',
    url: 'https://www.neuralampmodeler.com/users',
  },
  { name: 'NAM Universal', type: 'Plugin', url: 'https://wavemind.net/software' },
  { name: 'Two notes GENOME', type: 'Plugin', url: 'https://www.two-notes.com/en/product/genome/' },
  {
    name: 'MGuitarArchitect',
    type: 'Plugin',
    url: 'https://www.meldaproduction.com/MGuitarArchitect',
  },
  {
    name: 'Neural Amp Modeler LV2',
    type: 'Plugin',
    url: 'https://github.com/mikeoliphant/neural-amp-modeler-lv2',
  },
  { name: 'TooB Neural Amp Modeler', type: 'Plugin', url: 'https://github.com/rerdavies/ToobAmp' },
  { name: 'MOD Desktop', type: 'Application', url: 'https://mod.audio/' },
  {
    name: 'Neural Amp Modeler standalone application',
    type: 'Application',
    url: 'https://www.neuralampmodeler.com/users',
  },
  { name: 'MOD Audio platform', type: 'Application', url: 'https://mod.audio/' },
  {
    name: 'Nam XT: Neural Amp Modeler',
    type: 'Mobile App',
    url: 'https://apps.apple.com/us/app/nam-xt-neural-amp-modeler/id6502291697',
  },
  {
    name: 'GigFast Lite: Neural Amp Suite',
    type: 'Mobile App',
    url: 'https://apps.apple.com/us/app/gigfast-lite-neural-amp-suite/id6670697388',
  },
  {
    name: 'Neural Amp (NAM+AIDA-X) Model Loader',
    type: 'Mobile App',
    url: 'https://play.google.com/store/apps/details?id=com.dsp_tl.namaida',
  },
  { name: 'Dimehead NAM Player', type: 'Pedal/Device', url: 'https://dimehead.net/' },
  {
    name: 'Sonulab StompStation',
    type: 'Pedal/Device',
    url: 'https://sonulab.com/stompstation.html',
  },
  {
    name: 'Sonicake Pocket Master (QME-10)',
    type: 'Pedal/Device',
    url: 'https://www.sonicake.net/product/qme-10/',
  },
  {
    name: 'Darkglass Anagram',
    type: 'Pedal/Device',
    url: 'https://www.darkglass.com/creation/anagram/',
  },
  { name: 'Valeton GP-5', type: 'Pedal/Device', url: 'https://www.valeton.net/gp-5' },
  { name: 'Valeton GP-200', type: 'Pedal/Device', url: 'https://www.valeton.net/gp-200' },
  { name: 'Valeton GP-200JR', type: 'Pedal/Device', url: 'https://www.valeton.net/gp-200jr' },
  { name: 'MOD Audio Dwarf', type: 'Pedal/Device', url: 'https://mod.audio/products/mod-dwarf/' },
  { name: 'MOD Audio Duo', type: 'Pedal/Device', url: 'https://mod.audio/products/mod-duo/' },
  { name: 'MOD Audio DuoX', type: 'Pedal/Device', url: 'https://mod.audio/products/mod-duo-x/' },
  {
    name: 'Poly Effects AMPLE',
    type: 'Pedal/Device',
    url: 'https://www.polyeffects.com/products/ample',
  },
  {
    name: 'Hotone Ampero II',
    type: 'Pedal/Device',
    url: 'https://www.hotoneaudio.com/products/ampero-ii',
  },
  {
    name: 'Hotone Ampero II Stage',
    type: 'Pedal/Device',
    url: 'https://www.hotoneaudio.com/products/ampero-ii-stage',
  },
  {
    name: 'Hotone Ampero II Stomp',
    type: 'Pedal/Device',
    url: 'https://www.hotoneaudio.com/products/ampero-ii-stomp',
  },
];

const TypeBadge = ({ type }: { type: string }) => {
  const colorMap: Record<string, string> = {
    Plugin: 'text-zinc-400 border-zinc-400',
    Application: 'text-zinc-400 border-zinc-400',
    'Mobile App': 'text-zinc-400 border-zinc-400',
    'Pedal/Device': 'text-zinc-400 border-zinc-400',
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${
        colorMap[type] || 'bg-zinc-500/10 text-zinc-400 border-zinc-500/20'
      }`}
    >
      {type}
    </span>
  );
};

export const Integrations = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-zinc-800 rounded-lg overflow-hidden border border-zinc-700">
      <div className="bg-zinc-700 px-4 py-3 font-semibold text-white">Integrations</div>
      <div className="relative">
        <div
          className="overflow-x-auto transition-all duration-300"
          style={{
            maxHeight: isExpanded ? 'none' : '500px',
            overflow: isExpanded ? 'visible' : 'hidden',
          }}
        >
          <table className="w-full text-sm">
            <thead className="hidden bg-zinc-700/50">
              <tr>
                <th className="px-4 py-3 text-left font-semibold text-white">Name</th>
                <th className="px-4 py-3 text-left font-semibold text-white">Type</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-700">
              {integrations.map((integration, index) => (
                <tr key={index} className="hover:bg-zinc-700/30 transition-colors cursor-pointer">
                  <td className="px-4 py-3">
                    <a
                      href={integration.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white block"
                    >
                      {integration.name}
                    </a>
                  </td>
                  <td className="px-4 py-3">
                    <a
                      href={integration.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block"
                    >
                      <TypeBadge type={integration.type} />
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Blur overlay at bottom when collapsed */}
        {!isExpanded && (
          <div className="absolute bottom-0 left-0 right-0 h-[200px] bg-gradient-to-t from-zinc-800 via-zinc-800/80 to-transparent pointer-events-none z-0" />
        )}

        {/* View All / Show Less button */}
        {!isExpanded && (
          <div className="absolute bottom-0 left-0 right-0 pb-6 flex justify-center z-10">
            <Button
              isSecondary={true}
              onClick={() => setIsExpanded(!isExpanded)}
              className="text-sm sm:text-base"
            >
              {'View All'}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
